import React,{useState} from 'react'
import {getStudyMaterialMasterCardApi } from '../../actions/MasterCardAction'

const StudyMaterialMasterCard = ({paymentConfig}) => {
    const [loading,setLoading] = useState(false)

     const masterCardHandle = () => {
        setLoading(true)
        const data = {
          gateway_id: paymentConfig.id,
	        cancel_url:`${process.env.REACT_APP_PUBLIC_URL}/student/dashboard`,
	        success_url:`${process.env.REACT_APP_PUBLIC_URL}/student/studymaterial-payment-successfull` 
        }

        getStudyMaterialMasterCardApi(data).then((res) => {
            setLoading(true)
            if(res.status){
                setLoading(false)
                window.location.href=` ${process.env.REACT_APP_API_URL}/api/getmastercardSessionid/${res.session_id}`
            }
        })
    }
  return (
    <div>
        {loading ? <button type="submit" disabled className="banktransfer_btn">
                <span className="spinner-border spinner-border-sm me-3" role="status" aria-hidden="true"></span>
                Processing ...</button> : 
                <>
           <button 
           onClick={masterCardHandle} 
           className='banktransfer_btn'>Master Card</button>
           {/* <button className='banktransfer_btn'>Master Card</button> */}
        </>
        }
        </div>
  )
}

export default StudyMaterialMasterCard